module.exports = __webpack_public_path__ + "img/Resourceitem.53340e03.png";